import UAParser from 'ua-parser-js';

export default function v1() {
  const target = document.getElementsByClassName('v1')[0];
  if (!target) {
    return;
  }

  /**
   * htmlタグに国コードを追加します。
   */
  const addCountryCode = () => {
    const countryCode = window.location.pathname.split('/')[2];
    const htmlElement = document.getElementsByTagName('html')[0];

    htmlElement.classList.add(countryCode);
  };

  const parser = new UAParser();
  const isChrome = parser.getBrowser().name === 'Chrome';
  /**
   * Chromeで表示している場合はhtmlタグにクラスを追加します。
   */
  const addChromeClassName = () => target.classList.add('chrome');

  /**
   * サジェストを有効にしている場合は`true`、無効にしている場合は`false`にします。
   */
  const enableSuggest = true;

  /**
   * サジェスト機能をオフにした場合の属性値に上書きします。
   */
  const disableSuggestValue = selector => {
    const elements = document.querySelectorAll(selector);

    Array.from(elements).forEach(element => {
      element.setAttribute('aria-haspopup', 'false');
      element.setAttribute('aria-autocomplete', 'none');
      element.setAttribute('autocomplete', 'off');
    });
  };

  /**
   * サイト内検索のサジェスト関連の属性を無効にする。
   */
  const overwriteSuggestInput = () => {
    disableSuggestValue('.v1-headerSearch__input');
    disableSuggestValue('.v1-headerSearchSp__input');
    disableSuggestValue('.v1-resultInput__input');
  };

  addCountryCode();

  if (isChrome) {
    addChromeClassName();
  }

  if (!enableSuggest) {
    overwriteSuggestInput();
  }
}
